module.exports = __webpack_public_path__ + "static/media/average_star_G.3bfaaf3f.png";